import GlobalRanking from "./GlobalRanking";

export default GlobalRanking;
